import { libApiInstance } from '../axios';
import { InboxItemsRequest } from './types/InboxItemsRequest';
import { InboxItemsResponse } from './types/InboxItemsResponse';

export async function requestNewRecent(
    items: InboxItemsRequest,
    signal?: AbortSignal,
): Promise<InboxItemsResponse> {
    const result = await libApiInstance.post('/contacts/newandrecent', items, {
        signal,
    });
    return result.data;
}
